// Studyo Today Backend
// Package studyo.today.subscriptions.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/subscriptions/v1/resources/entitlement_value.proto (package studyo.today.subscriptions.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_subscriptions_v1_resources_entitlement } from "./entitlement_pb.js";
import { file_studyo_today_subscriptions_v1_resources_entitlement_value_kind } from "./entitlement_value_kind_pb.js";

/**
 * Describes the file studyo/today/subscriptions/v1/resources/entitlement_value.proto.
 */
export const file_studyo_today_subscriptions_v1_resources_entitlement_value = /*@__PURE__*/
  fileDesc("Cj9zdHVkeW8vdG9kYXkvc3Vic2NyaXB0aW9ucy92MS9yZXNvdXJjZXMvZW50aXRsZW1lbnRfdmFsdWUucHJvdG8SJ3N0dWR5by50b2RheS5zdWJzY3JpcHRpb25zLnYxLnJlc291cmNlcyLhAQoQRW50aXRsZW1lbnRWYWx1ZRJJCgtlbnRpdGxlbWVudBgBIAEoDjI0LnN0dWR5by50b2RheS5zdWJzY3JpcHRpb25zLnYxLnJlc291cmNlcy5FbnRpdGxlbWVudBJLCgRraW5kGAIgASgOMj0uc3R1ZHlvLnRvZGF5LnN1YnNjcmlwdGlvbnMudjEucmVzb3VyY2VzLkVudGl0bGVtZW50VmFsdWVLaW5kEhYKDG51bWJlcl92YWx1ZRgDIAEoBUgAEhQKCnRleHRfdmFsdWUYBCABKAlIAEIHCgV2YWx1ZUIvqgIsU3R1ZHlvLlRvZGF5LlN1YnNjcmlwdGlvbnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_studyo_today_subscriptions_v1_resources_entitlement, file_studyo_today_subscriptions_v1_resources_entitlement_value_kind]);

/**
 * Describes the message studyo.today.subscriptions.v1.resources.EntitlementValue.
 * Use `create(EntitlementValueSchema)` to create a new message.
 */
export const EntitlementValueSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_resources_entitlement_value, 0);

